import { t as localeText } from "@/i18n/translate";
import type { components } from "@/api/contract";
export type SkinSettings = components["schemas"]["V2SkinEnhancerSettings"];
export const skinDefaults: SkinSettings = { revision: "skin-v1", strength: 35, texture: 85, blemishes: true, even_tone: true, reduce_shine: true, under_eyes: false, preserve_freckles: true };
export const skinToggles = [
  { key: "blemishes", get label() { return localeText("interface.soften_blemishes_491127b4", { defaultValue: "Soften blemishes" }); } },
  { key: "even_tone", get label() { return localeText("interface.even_skin_tone_49b44f2d", { defaultValue: "Even skin tone" }); } },
  { key: "reduce_shine", get label() { return localeText("interface.reduce_shine_7459173a", { defaultValue: "Reduce shine" }); } },
  { key: "under_eyes", get label() { return localeText("interface.soften_under_eye_shadows_a9b02f8b", { defaultValue: "Soften under-eye shadows" }); } },
  { key: "preserve_freckles", get label() { return localeText("interface.preserve_freckles_f78e32b1", { defaultValue: "Preserve freckles" }); } },
] as const;

/** Choose the closest supported framing without claiming exact-size preservation. */
export function skinAspectRatio(width: number, height: number, ratios: string[]): string | undefined {
  if (width <= 0 || height <= 0) return undefined;
  return ratios.filter(ratio => /^\d+:\d+$/.test(ratio)).sort((a, b) => {
    const distance = (ratio: string) => { const [w, h] = ratio.split(":").map(Number); return Math.abs(Math.log((w! / h!) / (width / height))); };
    return distance(a) - distance(b);
  })[0];
}
